import { cryptoManager, getEnvVariable } from '@revbox/helpers-fe'

export const CRYPTO_KEY = getEnvVariable('REACT_APP_SECRET_KEY_256')

export const { encrypt, decrypt } = cryptoManager(CRYPTO_KEY)
